import { render, staticRenderFns } from "./VersionBuy.vue?vue&type=template&id=6367506b&scoped=true"
import script from "./VersionBuy.vue?vue&type=script&lang=js"
export * from "./VersionBuy.vue?vue&type=script&lang=js"
import style0 from "./VersionBuy.vue?vue&type=style&index=0&id=6367506b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367506b",
  null
  
)

export default component.exports